// extracted by mini-css-extract-plugin
export default {"generic-border-radius":"1px","genericBorderRadius":"1px","color-white":"#FFFFFF","colorWhite":"#FFFFFF","large":"only screen and (min-width: 992px)","wrapper":"qOYwj"};